/* Which player types are asked for a bowling start year. Same rule as
   server/utils/playerTypes.js: the club's own list once it has ticked or
   unticked anything, and until then every type with "social" in its name. */

export const START_YEAR_FIELD = 'yearsPlaying';

const isSocialName = type => /social/i.test(String(type || ''));

export function typesWithoutStartYear(saved, playerTypeOptions) {
  if (Array.isArray(saved)) return saved.map(String);
  return (playerTypeOptions || []).filter(isSocialName).map(String);
}

/** Whether the form should ask this person for a start year. */
export function asksStartYear(withoutList, playerType) {
  return !playerType || !(withoutList || []).includes(String(playerType));
}
